import React from "react";
import { Switch } from "antd";

const DetailsList = ({
  icon,
  title,
  description,
  switchChecked,
  onSwitchChange,
  onClick,
  required = false,
}) => {
  // console.log("description>>>", onSwitchChange, switchChecked)
  return (
    <div className="detail-item">
      <div
        className="detail-info"
        style={{ textAlign: "left" }}
        onClick={onClick}
      >
        <span className="icon ">{icon}</span>
        <div className="text">
          <p className="title">
            {title} {required && <span style={{ color: "red" }}>*</span>}
          </p>
          <p className="description">{description}</p>
        </div>
      </div>
      {switchChecked !== undefined && (
        <Switch
          className="custom-switch"
          checked={switchChecked}
          onChange={(checked) => {
            console.log("Switch toggled to:", checked); // Debugging
            if (typeof onSwitchChange === "function") {
              onSwitchChange(checked);
            }
          }}
        />
      )}
    </div>
  );
};

export default DetailsList;
